import { render, staticRenderFns } from "./AsignacionMunicion.vue?vue&type=template&id=322bf027"
import script from "./AsignacionMunicion.vue?vue&type=script&lang=js"
export * from "./AsignacionMunicion.vue?vue&type=script&lang=js"
import style0 from "./AsignacionMunicion.vue?vue&type=style&index=0&id=322bf027&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports